// extracted by mini-css-extract-plugin
module.exports = {"flex":"_1MsES6s"};
    if(module.hot) {
      // 1545369457915
      var cssReload = require("!../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  